export const main = '/';
export const securePrefix = '/panel';
export const prefix = '/bp';
export const login = `${prefix}/login`;
export const logout = `${prefix}/logout`;
export const registerFirmStep1 = `${prefix}/register-firm/step-1`;
export const registerFirmStep2 = `${prefix}/register-firm/step-2`;
export const registerFirmStep3 = `${prefix}/register-firm/step-3`;
export const registerFirmStep4 = `${prefix}/register-firm/step-4`;
export const registerSuccess = `${prefix}/register/success`;
export const dashboard = `${prefix}/dashboard`;
export const applicationReferred = `${prefix}/application-referred`;
export const application = `${prefix}/application`;
export const applicationDeclined = `${prefix}/application/:application_id/declined`;
export const registerNetworkStep1 = `${prefix}/register-network/step-1`;
export const clubRegistrationStep1 = `${prefix}/register-club/step-1`;
export const clubRegistrationStep2 = `${prefix}/register-club/step-2`;
export const register = `${prefix}/register`;
export const registerSearchFirms = `${register}/search-firms`;
export const registerRegisterFirm = `${register}/register-firm`;
export const registerPersonalDetails = `${register}/personal-details`;
export const registerDueDiligence = `${register}/due-diligence`;
export const registerSetPassword = `${register}/set-password`;
export const registerVerification = `${register}/verify`;
export const triage = `${prefix}/triage`;

export const clubs = {
  list: `${prefix}/clubs`,
  details: `${prefix}/club`,
};

export const password = {
  reset: `${prefix}/reset-password`,
  forgot: `${prefix}/forgot-password`,
  set: `${prefix}/set-password`,
};

export const quotes = `${prefix}/tasks`;
export const firms = {
  list: `${prefix}/firms`,
  details: `${prefix}/firm`,
  managersList: `${prefix}/firm/:id/managers`,
};
export const networks = {
  list: `${prefix}/networks`,
  details: `${prefix}/network`,
};

export const advisers = {
  search: `${prefix}/advisers/search`,
  list: `${prefix}/advisers/list`,
  details: `${prefix}/adviser-details`,
  add: `${prefix}/adviser/add`,
  addSuccess: `${prefix}/add/success`,
};
export const admins = {
  list: `${prefix}/firm-admins`,
  register: `${prefix}/admins/register`,
  companyDetails: `${prefix}/admins/register/company-details`,
};

export const profile = `${prefix}/profile`;

export const productReselect = `${prefix}/product-reselect`;

export const afTool = {
  index: `${prefix}/af-tool`,
};

export const caseManagement = {
  index: `${securePrefix}/cm`,
  caseById: `${securePrefix}/cm/:case_id`,
};

export const guides = `${prefix}/guides`;

export const commissionTerms = {
  index: `${securePrefix}/commission-terms`,
  create: `${securePrefix}/commission-terms/create`,
  update: `${securePrefix}/commission-terms/:id`,
};

export const user = {
  edit: `${prefix}/user/:id`,
};
